import { createFeatureFlagHooks } from './useFeatureFlag';
import { useFeatureFlagBase } from './useFeatureFlagBase';

export const { useFeatureFlag, useFeatureFlagEnabled } =
  createFeatureFlagHooks(useFeatureFlagBase);

export { useSetFeatureFlag } from './useSetFeatureFlag';
export { FeatureFlagDevProvider } from './FeatureFlagDevProvider';
export { FeatureFlagDevContext } from './FeatureFlagDevContext';
